import React from "react";
import capitalizeFirstLetter from "@/shared/utils/capitalize-first-letter";
import { IPotentialIssue } from "./PotentialIssues";
import { Chip } from "@nextui-org/react";

export const PotentialIssueSeverityBadge = (data: IPotentialIssue) => {
  // Using the same style mapping as in fair-formatting.ts getRatingStyle
  const severityStyles = {
    'low': 'bg-[#D1F4E0] text-[#45D483]',      // Maps to 'Low' in FAIR
    'medium': 'bg-[#FDEDD3] text-[#F5A524]',   // Maps to 'Moderate' in FAIR
    'high': 'bg-[#FDD0DF] text-[#F31260]',     // Maps to 'High' in FAIR
    'critical': 'bg-red-200 text-red-900',     // Maps to 'Very High' in FAIR
  };
  
  const severityKey = (data.severity || "").toLowerCase();
  const styleClass = severityStyles[severityKey as keyof typeof severityStyles] || "";
  
  return (
    <span className={`px-2 py-1 rounded-full text-xs font-normal ${styleClass}`}>
      {data.severity ? capitalizeFirstLetter(data.severity) : ""}
    </span>
  );
}; 